var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrightLikes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95602 14.3403C6.05632 14.0673 6.44238 14.0673 6.54268 14.3403L7.15026 15.9939C7.46654 16.8547 8.14496 17.5331 9.00576 17.8494L10.6594 18.457C10.9323 18.5573 10.9323 18.9434 10.6594 19.0437L9.00576 19.6512C8.14496 19.9675 7.46654 20.6459 7.15026 21.5067L6.54268 23.1603C6.44238 23.4333 6.05632 23.4333 5.95602 23.1603L5.34844 21.5067C5.03216 20.6459 4.35374 19.9675 3.49294 19.6512L1.83934 19.0437C1.56637 18.9434 1.56637 18.5573 1.83934 18.457L3.49294 17.8494C4.35374 17.5331 5.03216 16.8547 5.34844 15.9939L5.95602 14.3403Z",
    fill: "url(#paint0_linear_394_35901)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4157 11.2153C17.516 10.9423 17.902 10.9423 18.0023 11.2153L18.8898 13.6307C19.2061 14.4915 19.8845 15.1699 20.7453 15.4862L23.1607 16.3737C23.4336 16.474 23.4336 16.86 23.1607 16.9603L20.7453 17.8478C19.8845 18.1641 19.2061 18.8425 18.8898 19.7033L18.0023 22.1187C17.902 22.3916 17.516 22.3916 17.4157 22.1187L16.5282 19.7033C16.2119 18.8425 15.5335 18.1641 14.6727 17.8478L12.2573 16.9603C11.9843 16.86 11.9843 16.474 12.2573 16.3737L14.6727 15.4862C15.5335 15.1699 16.2119 14.4915 16.5282 13.6307L17.4157 11.2153Z",
    fill: "url(#paint1_linear_394_35901)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1233 1.84031C10.2236 1.56735 10.6097 1.56735 10.71 1.84031L11.8774 5.01746C12.1937 5.87826 12.8721 6.55668 13.7329 6.87296L16.91 8.04033C17.183 8.14063 17.183 8.52669 16.91 8.62699L13.7329 9.79436C12.8721 10.1106 12.1936 10.7891 11.8774 11.6499L10.71 14.827C10.6097 15.1 10.2236 15.1 10.1233 14.827L8.95596 11.6499C8.63968 10.7891 7.96126 10.1106 7.10047 9.79436L3.92332 8.62698C3.65036 8.52669 3.65036 8.14063 3.92332 8.04033L7.10047 6.87296C7.96126 6.55667 8.63968 5.87825 8.95596 5.01746L10.1233 1.84031Z",
    fill: "url(#paint2_linear_394_35901)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_394_35901",
    x1: 6.24935,
    y1: 17.0653,
    x2: 6.24935,
    y2: 23.9587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9252E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3CE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_394_35901",
    x1: 17.709,
    y1: 14.6449,
    x2: 17.709,
    y2: 22.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9252E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3CE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_394_35901",
    x1: 10.4167,
    y1: 5.97459,
    x2: 10.4167,
    y2: 15.6253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9252E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3CE5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightLikes);
export default __webpack_public_path__ + "static/media/BrightLikes.c4ee389da5ced53d96fe8c71ec2e6d8e.svg";
export { ForwardRef as ReactComponent };